<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
  >
    <template #header>
      <Tabs type="card" v-model="agent" @on-click="handleTab">
        <TabPane
          v-for="item in agentList"
          :key="item.id"
          :label="item.agent"
          :name="item.agent"
        />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import {
  getAgents,
  getAgentTrace,
  add,
  update,
  del,
  getDetails,
} from "@/api/order/tracker";
import { getStatus } from "@/api/tracker/status";
import cTable from "@/base/common/index.vue";
export default {
  name: "trace",
  components: {
    cTable,
  },
  methods: {
    handleTab(tab) {
      this.$refs["table"].agent = this.agent;
      this.$refs["table"].getList(1);
    },
  },
  data() {
    let statusList = [
        { label: this.$t("YES"), value: "YES" },
        { label: this.$t("NO"), value: "NO" },
      ],
      mappingList = [
        {
          label: this.$t("agentT") + this.$t("trajectory") + this.$t("exlType"),
          value: 1,
        },
        {
          label: this.$t("agentT") + this.$t("trajectory") + this.$t("deSc"),
          value: 2,
        },
      ];
    return {
      agent: "",
      agentList: [],
      methods: {
        list: async (params) => {
          if (!this.agentList.length) {
            let res = await getAgents();
            this.agentList = res.data.payload;
            this.agent = res.data.payload[0].agent;
            this.$nextTick(() => {
              this.$refs["table"].handleResize();
            });
          }
          params["agent"] = this.agent;
          return getAgentTrace(params);
        },
        add,
        getStatus,
        update,
        del,
        getDetails,
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              console.log(row);
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              agent_remarks: [
                {
                  required: true,
                  message: "agent_remarks cannot be empty",
                  trigger: "blur",
                },
              ],
              agent_status: [
                {
                  required: true,
                  message: "agent_status cannot be empty",
                  trigger: "blur",
                },
              ],
              status: [
                {
                  required: true,
                  message: "status cannot be empty",
                  trigger: "blur",
                },
              ],
              sort: [
                {
                  required: true,
                  type: "number",
                  message: "sort cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { agent: 24 },
            { mapping_type: 24 },
            { vnlin_status: 24 },
            { agent_status: 24 },
            { agent_remarks: 24 },
            { sort: 24 },
            { status: 24 },
          ],
          fields: [
            {
              key: "agent",
              name: () => this.$t("agentName"),
              component: "Input",
              disabled: true,
              default: () => this.agent,
              placeholder() {
                return this.$t("enter") + this.$t("agentName");
              },
            },
            {
              key: "mapping_type",
              name: () => this.$t("mapping1") + this.$t("type"),
              component: "Radio",
              bind: {
                border: true,
              },
              options: mappingList,
              default: 1,
            },
            {
              key: "vnlin_status",
              name: () => this.$t("vnlinTrackCode"),
              component: "Select",
              config: {
                label: "tracker_code",
                value: "tracker_code",
              },
              placeholder() {
                return this.$t("select") + this.$t("vnlinTrackCode");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getStatus")
                  ).payload.rows;
                  this.$forceUpdate();
                },
              },
            },
            {
              key: "agent_status",
              name: () => this.$t("AgentTrajectory") + this.$t("code"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("AgentTrajectory") +
                  this.$t("exlType")
                );
              },
            },
            {
              key: "agent_remarks",
              name: () => this.$t("AgentTrajectory") + this.$t("deSc"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("AgentTrajectory") +
                  this.$t("deSc")
                );
              },
            },
            {
              key: "sort",
              name: () => this.$t("sort"),
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
              },
              default: 1,
              placeholder() {
                return this.$t("enter") + this.$t("sort");
              },
            },
            {
              key: "status",
              name: () => this.$t("status"),
              component: "Radio",
              bind: {
                border: true,
              },
              options: statusList,
              default: "YES",
            },
          ],
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add",
              },
            },
          ],
          methods: {
            addFun() {
              this.getModal("add").setTitle(this.$t("add"));
              this.getModal("add").open();
            },
          },
        },
      },
      fields: [
        {
          type: "btns",
          width: 270,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              id: 1805,
              bind: {
                type: "error",
              },
            },
          ],
          methods: {
            async updateFun({ row }) {
              console.log(row);
              let res = await this.handleRequestMethods("getDetails", row.id);
              console.log("res", res);
              this.getModal("add").open(res.payload, function () {
                this.setTitle(this.$t("add"));
              });
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("createTime") +
                  ":" +
                  row.create_time +
                  this.$t("trace") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("del", row.id, true).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
          },
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 160,
        },
        {
          name: () => this.$t("mapping1") + this.$t("type"),
          key: "mapping_type",
          width: 150,
        },
        {
          name: () => this.$t("AgentTrajectory") + this.$t("code"),
          key: "agent_status",
          align: "left",
          minWidth: 100,
        },
        {
          name: () => this.$t("AgentTrajectory") + this.$t("deSc"),
          key: "agent_remarks",
          align: "left",
          minWidth: 100,
        },
        {
          name: () => this.$t("vnlinTrackCode"),
          key: "vnlin_status",

          width: 110,
        },
        {
          name: () => this.$t("status"),
          key: "status",

          width: 100,
          methods: {
            render({ value }) {
              return statusList.find((item) => item.value == value).label;
            },
          },
        },
        {
          name: () => this.$t("sort"),
          key: "sort",

          width: 80,
        },
      ],
    };
  },
  created() {},
};
</script>

<style lang="scss" scoped></style>
